module.exports = function() {
  return new Worker(__webpack_public_path__ + "4f388f864b4ad6ff93f3.worker.js");
};